import { render, staticRenderFns } from "./Contratos.vue?vue&type=template&id=12b88e1b&scoped=true&"
import script from "./contratos.js?vue&type=script&lang=js&"
export * from "./contratos.js?vue&type=script&lang=js&"
import style0 from "./Contratos.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./Contratos.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fscss&"
import style2 from "./Contratos.vue?vue&type=style&index=2&lang=css&"
import style3 from "./Contratos.vue?vue&type=style&index=3&id=12b88e1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b88e1b",
  null
  
)

export default component.exports